import React, { useMemo, useCallback, useState, useEffect } from "react";
import TableContainer from "../../../components/Common/TableContainer.js";
import Breadcrumbs from "../../../components/Common/Breadcrumb.js";
import { Card, CardBody, Button, Container } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { generateColumns } from "../../../custom/Utils/ColumnUtils.js";
import useFetchData from "../../../custom/Utils/UseFetchDataUtils.js";
import usePagination from "../../../custom/Utils/UsePaginationUtils.js";
import { listPageData, exportPageData } from "./ItemIntakeFile.js";
import { getRecords } from "../../../services/api.service.js";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";

const ItemIntakeList = () => {
  const navigate = useNavigate();
  const {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  } = listPageData();
  const initialPayload = useMemo(() => payload, []);

  // pagination
  const {
    page,
    pageSize,
    nextPage,
    previousPage,
    lastPage,
    firstPage,
    handlePageSizeChange,
    setPage,
  } = usePagination();

  // fetch data using the provided payload, page, and page size
  const { data, isLoading, setSearchKeyword, totalCount } = useFetchData(
    initialPayload,
    page,
    pageSize,
    endpoint,
    searchfields
  );
  const [dataForExport, setDataForExport] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const getOnlyDate = (date) => {
    const receivedDate = new Date(date).toLocaleDateString();
    const [day, month, year] = receivedDate?.split("/");
    const formatted = `${year}-${month}-${day}`;
    return formatted;
  };
  const location = useLocation();

  useEffect(() => {
    if (data) {
      const newArray = data.map((item) => {
        return {
          ...item,
          is_repairable:
            item?.is_repairable === null || item?.is_repairable === undefined
              ? "-"
              : item.is_repairable === true
              ? "Yes"
              : "No",
          items_matching_invoice:
            item?.items_matching_invoice === null ||
            item?.items_matching_invoice === undefined
              ? "-"
              : item.items_matching_invoice === true
              ? "Yes"
              : "No",
          anti_static_bag:
            item?.anti_static_bag === null ||
            item?.anti_static_bag === undefined
              ? "-"
              : item.anti_static_bag === true
              ? "Yes"
              : "No",
          fault_tag_attached:
            item?.fault_tag_attached === null ||
            item?.fault_tag_attached === undefined
              ? "-"
              : item.fault_tag_attached === true
              ? "Yes"
              : "No",
          received_date: item.received_date
            ? getOnlyDate(item.received_date)
            : "-",
          inspected_by_full_name: item.inspected_by_user
            ? `${item.inspected_by_user.first_name} ${item.inspected_by_user.last_name}`
            : "-",
          received_by_full_name: item.received_by_user
            ? `${item.received_by_user.first_name} ${item.received_by_user.last_name}`
            : "-",
        };
      });
      setUpdatedData(newArray);
    }
  }, [data]);

  // handle create action
  const handleCreate = () => navigate(navigatePage.create);

  // handle edit action
  // const handleEdit = useCallback(
  //   (id) => {
  //     navigate(navigatePage.edit + "/" + id);
  //   },
  //   [navigate, navigatePage.edit]
  // );

  const handleView = useCallback(
    (id) => {
      navigate(navigatePage.view + "/" + id);
    },
    [navigate, navigatePage.view]
  );

  // columns data
  const columns = useMemo(
    () =>
      generateColumns(
        data,
        columnData,
        null,
        handleView,
        page,
        pageSize,
        null,
        location.pathname
      ),
    [data, columnData, handleView, page, pageSize, location.pathname]
  );

  // handle page size change callback
  const handlePageSizeChangeWrapper = useCallback(
    (newSize) => {
      handlePageSizeChange(newSize, totalCount);
    },
    [totalCount]
  );

  useEffect(() => {
    const handleExportData = async () => {
      try {
        const responseData = await getRecords(exportPageData, endpoint);
        setDataForExport(responseData?.data);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    handleExportData();
  }, []);

  const exportData = dataForExport?.map((item, index) => ({
    "Sr. No": index + 1,
    "MENU NAME": item?.menu_name || "N/A",
    "MENU URL": item?.menu_url || "N/A",
    "MENU ICON": item?.menu_icon || "N/A",
    "CREATED BY": item?.createdBy?.first_name || "N/A",
    STATUS:
      item?.is_active === false || item?.is_active === 0
        ? "In-active"
        : "Active",
    "IS CHILD": item?.is_child === false || item?.is_child === 0 ? "NO" : "YES",
    "IS VISIBLE ON MOBILE":
      item?.is_visible_on_mobile === false || item?.is_visible_on_mobile === 0
        ? "NO"
        : "YES",
  }));

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumbs title={headerName + " List"} breadcrumbItems={[]} />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleCreate}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create {headerName}
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={updatedData || []}
                isLoading={isLoading}
                onSearchInputData={setSearchKeyword}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChangeWrapper}
                nextToPage={nextPage}
                lastToPage={() => lastPage(totalCount)}
                previousToPage={previousPage}
                previousFirstToPage={firstPage}
                totalCount={totalCount}
                customPageSize={pageSize}
                exportData={exportData}
                exportFileName={exportFileName}
              />
            </CardBody>
          </Card>
          {/* Loader Overlay */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ItemIntakeList;
